import React, { useMemo, useState } from "react"
import {
  SectionCard,
  QuickChip,
  ExecutiveSimpleTable,
  planInputStyle as inputStyle,
  planButtonStyle as buttonStyle,
  planLabelStyle as labelStyle
} from "./PlanPrimitives"

export default function PlanQueueSection({
  isMobile,
  mobileCards,
  effectivePatientId,
  search,
  setSearch,
  clearFilters,
  quickFilter,
  setQuickFilter,
  statusFilter,
  setStatusFilter,
  financialFilter,
  setFinancialFilter,
  tableHeaders,
  rowsForTable
}) {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false)

  const advancedFiltersActiveCount = useMemo(() => {
    let count = 0
    if (statusFilter !== "ALL") count += 1
    if (financialFilter !== "ALL") count += 1
    return count
  }, [statusFilter, financialFilter])

  return (
    <SectionCard
      title={effectivePatientId ? "Lista de planes del paciente" : "Lista de planes"}
      right={
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            onClick={() => setShowAdvancedFilters((prev) => !prev)}
            style={{ ...buttonStyle, background: "#ffffff" }}
          >
            {showAdvancedFilters
              ? "Ocultar filtros"
              : advancedFiltersActiveCount > 0
                ? `Más filtros (${advancedFiltersActiveCount})`
                : "Más filtros"}
          </button>

          <button
            onClick={clearFilters}
            style={{ ...buttonStyle, background: "#f8fafc" }}
          >
            Limpiar
          </button>
        </div>
      }
    >
      <div style={{ display: "grid", gap: 14 }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr)",
            gap: 12
          }}
        >
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Buscar por título o notas del plan"
            style={inputStyle}
          />

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <QuickChip
              active={quickFilter === "ALL"}
              label="Todos"
              onClick={() => setQuickFilter("ALL")}
            />
            <QuickChip
              active={quickFilter === "REQUIRES_ACTION"}
              label="Requieren acción"
              onClick={() => setQuickFilter("REQUIRES_ACTION")}
            />
            <QuickChip
              active={quickFilter === "WITHOUT_APPOINTMENT"}
              label="Sin cita"
              onClick={() => setQuickFilter("WITHOUT_APPOINTMENT")}
            />
            <QuickChip
              active={quickFilter === "WITH_PENDING_ITEMS"}
              label="Con ítems pendientes"
              onClick={() => setQuickFilter("WITH_PENDING_ITEMS")}
            />
            <QuickChip
              active={quickFilter === "WITH_BALANCE"}
              label="Con saldo"
              onClick={() => setQuickFilter("WITH_BALANCE")}
            />
          </div>
        </div>

        {showAdvancedFilters ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 280px))",
              gap: 12,
              padding: 14,
              borderRadius: 14,
              border: "1px solid #e2e8f0",
              background: "#f8fafc"
            }}
          >
            <div>
              <div style={labelStyle}>Estatus</div>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                style={inputStyle}
              >
                <option value="ALL">Todos</option>
                <option value="ACTIVE">Activos</option>
                <option value="COMPLETED">Completados</option>
                <option value="CANCELLED">Cancelados</option>
              </select>
            </div>

            <div>
              <div style={labelStyle}>Situación financiera</div>
              <select
                value={financialFilter}
                onChange={(e) => setFinancialFilter(e.target.value)}
                style={inputStyle}
              >
                <option value="ALL">Todos</option>
                <option value="WITH_BALANCE">Con saldo pendiente</option>
                <option value="WITHOUT_BALANCE">Sin saldo pendiente</option>
              </select>
            </div>
          </div>
        ) : null}

        {isMobile ? (
          mobileCards
        ) : (
          <ExecutiveSimpleTable
            headers={tableHeaders}
            rows={rowsForTable}
            emptyLabel={
              effectivePatientId
                ? "Sin planes registrados para este paciente con los filtros actuales."
                : "Sin planes registrados en esta clínica con los filtros actuales."
            }
          />
        )}
      </div>
    </SectionCard>
  )
}